/* eslint-disable */
import requestRaw from '@/utils/requestRaw'
import requestDev from '@/utils/requestDev'

import { APICore, APICoreV2, APIReportPHP } from '@/utils/servicesApi'
const qs = require('qs')

export function deleteKB(data) {
  return requestRaw({
    url: APICoreV2() + '/aiclient/delete-kb?id=' + data.id + "&license_id=" + data.license_id,
    method: 'GET',
  })
}

export function historyListKB(params) {
  return requestDev({
    url: APIReportPHP() + '/ai/history/list-kb',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function knowledgeBaseSummary(data) {
  return requestRaw({
    url: APICoreV2() + '/aiclient/knowledge-base/summary',
    method: 'POST',
    data: data,
    silent: true
  })
}

export function knowledgeBaseChunks(data) {
  return requestRaw({
    url: APICoreV2() + '/aiclient/knowledge-base/chunks',
    method: 'POST',
    data: data,
    silent: true
  })
}

export function knowledgeBaseChunkDetail(data) {
  return requestRaw({
    url: APICoreV2() + '/aiclient/knowledge-base/chunk',
    method: 'POST',
    data: data,
    silent: true
  })
}

export function knowledgeBaseSearch(data) {
  return requestRaw({
    url: APICoreV2() + '/aiclient/knowledge-base/search',
    method: 'POST',
    data: data,
    silent: true
  })
}

// Monitoring antrean pemrosesan Knowledge Base (go-omni / route group /omni).
export function knowledgeBaseJobDetail(data) {
  return requestRaw({
    url: APICore() + '/omni/knowledge-base/jobs/' + encodeURIComponent(data.job_id),
    method: 'GET',
    silent: true
  })
}

export function knowledgeBaseJobChunks(params) {
  return requestRaw({
    url: APICore() + '/omni/knowledge-base/jobs/' + encodeURIComponent(params.job_id) + '/chunks',
    method: 'GET',
    params: {
      page: params.page,
      limit: params.limit,
      status: params.status
    },
    silent: true
  })
}

export function knowledgeBaseLatestJob(params) {
  return requestRaw({
    url: APICore() + '/omni/knowledge-base/jobs/latest',
    method: 'GET',
    params: {
      file_id: params.file_id,
      license_id: params.license_id
    },
    silent: true
  })
}

// Isi lengkap dokumen untuk editor. Lazy extraction dokumen lama dapat
// memakan waktu lebih lama dari timeout default, jadi timeout diperbesar.
export function knowledgeBaseFileContent(params) {
  return requestRaw({
    url: APICore() + '/omni/knowledge-base/files/' + encodeURIComponent(params.file_id) + '/content',
    method: 'GET',
    params: params.license_id ? { license_id: params.license_id } : {},
    timeout: 120000,
    silent: true
  })
}

export function updateKnowledgeBaseFileContent(data) {
  return requestRaw({
    url: APICore() + '/omni/knowledge-base/files/' + encodeURIComponent(data.file_id) + '/content',
    method: 'PUT',
    data: {
      text: data.text,
      content_version: data.content_version,
      idempotency_key: data.idempotency_key || ''
    },
    timeout: 60000,
    silent: true
  })
}

export function retryKnowledgeBaseJob(params) {
  return requestRaw({
    url: APICore() + '/omni/knowledge-base/jobs/' + encodeURIComponent(params.job_id) + '/retry',
    method: 'POST',
    timeout: 60000,
    silent: true
  })
}
export function createSchedule(data) {
  return requestRaw({
    url: APICoreV2() + '/aiclient/autofollowup/followup-with-message',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function regenerateSuggest(data) {
  return requestRaw({
    url: APICoreV2() + '/aiclient/autofollowup/regenerate-suggest',
    method: 'POST',
    data: data // untuk array data post
  })
}
export function registerTrial(data) {
  return requestRaw({
    url: APICoreV2() + '/aiclient/register-trial',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function summaryFollowup(data) {
  return requestRaw({
    url: APICoreV2() + '/aiclient/report/summary-followup',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function summaryDelete(data) {
  return requestRaw({
    url: APICoreV2() + '/aiclient/report/summary-delete',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function sessionDestroy(data) {
  return requestRaw({
    url: APICoreV2() + '/aiclient/report/session-destroy',
    method: 'POST',
    data: data, // untuk array data post
    silent: true
  })
}

export function sessionStart(data) {
  return requestRaw({
    url: APICoreV2() + '/aiclient/report/session-start',
    method: 'POST',
    data: data, // untuk array data post
    silent: true
  })
}

export function sessionDelete(data) {
  return requestRaw({
    url: APICoreV2() + '/aiclient/report/session-delete',
    method: 'POST',
    data: data, // untuk array data post
    silent: true
  })
}

export function sessionPause(data) {
  return requestRaw({
    url: APICoreV2() + '/aiclient/report/session-pause',
    method: 'POST',
    data: data, // untuk array data post
    silent: true
  })
}
export function listSummary(params) {
  return requestDev({
    url: APIReportPHP() + '/ai/list-summary',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function listSummaryExcel(params) {
  return requestDev({
    url: APIReportPHP() + '/ai/list-summary-excel',
    method: 'POST',
    data: qs.stringify(params)
  })
}


export function listSessions(params) {
  return requestDev({
    url: APIReportPHP() + '/ai/list-sessions',
    method: 'POST',
    data: qs.stringify(params),
    silent: true
  })
}


export function listSessionsExcel(params) {
  return requestDev({
    url: APIReportPHP() + '/ai/list-sessions-excel',
    method: 'POST',
    data: qs.stringify(params),
    silent: true
  })
}

export function setupKey(data) {
  return requestRaw({
    url: APICoreV2() + '/aiclient/setup',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function getAIKey() {
  return requestRaw({
    url: APICoreV2() + '/aiclient/key',
    method: 'GET',
  })
}

export function getBalance() {
  return requestRaw({
    // url: APICoreV2() + '/aiclient/deepseek/get-balance',
    url: APICoreV2() + '/aiclient/get-balance',
    method: 'GET',
  })
}


export function getDetail() {
  return requestRaw({
    url: APICoreV2() + '/aiclient/detail',
    method: 'GET',
  })
}
export function getLanguageStyle() {
  return requestRaw({
    url: APICoreV2() + '/aiclient/broadcast/language-style',
    method: 'GET',
  })
}

  export function getRecommendationText(data) {
    return requestRaw({
      url: APICoreV2() + '/aiclient/broadcast/get-recommendation',
      method: 'POST',
      data: data // untuk array data post
    })
  }



  export function listIntentWorkflowUser(params) {
    return requestDev({
        url: APIReportPHP() + '/ai/list-intent-user',
        method: 'POST',
        data: qs.stringify(params)
    })
  }
  


// WEBPACK FOOTER //
// ./src/api/aiKey.js